import { API, API_GET } from "../../config";

export const GetFaq = () => {
  return API_GET(API.GetFaq);
};
